module.exports = __webpack_public_path__ + "assets/6a248f97e6ce7d5fe2d4adfb4223d152.mp3";